import { h, Component} from 'preact';
import Match from 'preact-router/match';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

const Link = ({ activeClassName, class: c, path, partial, ...props }) => (
  <Match path={path}>
    {({ matches, path: p }) =>
      <a {...props} class={matches || partial && p.startsWith(partial) ? activeClassName : c} />
    }
  </Match>
);

const Nav = (props) => (
    <nav {...props}>
        <Link activeClassName={cx("active")} href="/search/list/" partial="/search">Search Engines</Link>
        <Link activeClassName={cx("active")} href="/team/management/" partial="/team/management">Team Managment</Link>
        <Link activeClassName={cx("active")} href="/logout">Log out</Link>
    </nav>
)

class MobileMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mobileMenuOpen: false
        }
    }
    
    
    render() {
        return (
            <div>
                <div onClick={() => this.setState({mobileMenuOpen: true})} class={cx("burgerButton")}>
                    <i class="fas fa-bars"></i>
                </div>
                <div class={cx("mobile-menu", {"mobile-menu-open": this.state.mobileMenuOpen})}>
                    <div onClick={() => this.setState({mobileMenuOpen: false})} class={cx("burgerButton")} style={{alignSelf: "flex-end"}}>
                        <i class="fas fa-times"></i>
                    </div>
                    <Nav 
                        class={cx("mobile-nav")}
                    />
                </div>
            </div>
        )
    }
}

const Header = (props) => (
	<header class={style.header}>
		<h1>🔍Curatr</h1>
		<Nav class={cx("desktop-nav")} />
        <div class={cx("border")} />
        <MobileMenu />
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js